import { io } from "socket.io-client";

// Conexión Socket.IO única y compartida para todo el frontend (widgets,
// dashboards, procesos). Antes cada hook (ej. useProcessSocket) abría su
// propia conexión `io(...)`, lo que significaba un socket nuevo por cada
// widget montado. Con muchos dashboards/widgets eso también pesa del lado
// del cliente y del servidor (una conexión TCP/WS por widget). Este módulo
// crea la conexión una sola vez (lazy, al primer uso) y la reutiliza.
let socket = null;

// El socket.io-server NO vive en la misma URL que la API REST (esa incluye
// el prefijo /v1). Si falta REACT_APP_SOCKET_URL, socket.io-client conecta
// contra el propio origen del frontend por defecto, que no tiene servidor
// de sockets: la conexión nunca se establece, no hay ningún error visible,
// y cualquier widget que dependa del socket se queda "cargando" para
// siempre. Como red de seguridad, si falta la variable la derivamos de
// REACT_APP_BACKEND_URL quitándole el prefijo de la API.
const resolveSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) return process.env.REACT_APP_SOCKET_URL;

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    console.warn(
      "[socketClient] REACT_APP_SOCKET_URL no está definida; derivando la URL del socket desde REACT_APP_BACKEND_URL. Definí REACT_APP_SOCKET_URL en el .env para evitar esto."
    );
    try {
      const url = new URL(backendUrl);
      return `${url.protocol}//${url.host}`;
    } catch (e) {
      // backendUrl no es una URL absoluta válida, seguimos sin socketUrl
    }
  }
  return undefined;
};

export function getSocket() {
  if (!socket) {
    const socketUrl = resolveSocketUrl();
    socket = io(socketUrl, { transports: ["websocket"] });

    socket.on("connect", () => {
      console.log("✅ Socket compartido conectado", socket.id);
    });
    socket.on("connect_error", (err) => {
      console.error("❌ Error de conexión del socket compartido:", err.message);
    });
    socket.on("disconnect", (reason) => {
      console.log("🔌 Socket compartido desconectado:", reason);
    });
  }
  return socket;
}

export default getSocket;
